export function getReferrer() {
  // if inside iframe
  if (window !== window.parent) {
    // extract origin from referrer url -- ex. https://ygrene.com from https://ygrene.com/abc/def
    return document.referrer.split('/').slice(0, 3).join('/');
  }
  return location.origin;
}
